const footerLinksData = [
    {
        title: 'Top Destinations',
        items: [
            {
                title: 'Las Vegas',
                href: 'https://www.wingie.com/flights/to-las-vegas/',
            },
            {
                title: 'Chicago',
                href: 'https://www.wingie.com/flights/to-chicago/',
            },
            {
                title: 'Miami',
                href: 'https://www.wingie.com/flights/to-miami/',
            },
            {
                title: 'Cancun',
                href: 'https://www.wingie.com/flights/to-cancun/',
            },
            {
                title: 'London',
                href: 'https://www.wingie.com/flights/to-london/',
            },
            {
                title: 'Honolulu',
                href: 'https://www.wingie.com/flights/to-honolulu/',
            },
        ],
    },
    {
        title: 'Popular Countries',
        items: [
            {
                title: 'Canada',
                href: 'https://www.wingie.com/flights/ca-canada/',
            },
            {
                title: 'China',
                href: 'https://www.wingie.com/flights/cn-china/',
            },
            {
                title: 'Costa Rica',
                href: 'https://www.wingie.com/flights/cr-costa-rica/',
            },
            {
                title: 'Dominican Republic',
                href: 'https://www.wingie.com/flights/do-dominican-republic/',
            },
            {
                title: 'El Salvador',
                href: 'https://www.wingie.com/flights/sv-el-salvador/',
            },
            {
                title: 'France',
                href: 'https://www.wingie.com/flights/fr-france/',
            },
        ],
    },
    {
        title: 'Popular Airlines',
        items: [
            {
                title: 'American Airlines',
                href: 'https://www.wingie.com/flights/airlines/american-airlines/',
            },
            {
                title: 'Delta Air lines',
                href: 'https://www.wingie.com/flights/airlines/delta-air-lines/',
            },
            {
                title: 'United Airlines',
                href: 'https://www.wingie.com/flights/airlines/united-airlines/',
            },
            {
                title: 'Alaska Airlines',
                href: 'https://www.wingie.com/flights/airlines/alaska-airlines/',
            },
            {
                title: 'JetBlue',
                href: 'https://www.wingie.com/flights/airlines/jetblue/',
            },
            {
                title: 'Hawaiian Airlines',
                href: 'https://www.wingie.com/flights/airlines/hawaiian-airlines/',
            },
        ],
    },
]

export default footerLinksData
